import { render, staticRenderFns } from "./ShortTypeBadge.vue?vue&type=template&id=20d99300&"
import script from "./ShortTypeBadge.vue?vue&type=script&lang=ts&"
export * from "./ShortTypeBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports